<div class="w-full pr-8">
  <div class="text-center border-b border-teal-400">
    <div (click)="tabClicked.emit()" [ngClass]="active ? 'text-primary border-b-2 border-primary w-full' : 'text-gray-400'"
      class="outline-none inline-block font-bold pb-2 cursor-pointer md: lg: xl:">
      {{ tabName }}
    </div>
  </div>
</div>